import {RouteConfig} from '@famly/vet_navigation_route-config';

/**
 * Whether a router pathname shows the login screen. The root path counts because the router
 * redirects it there.
 */
export const isLoginScreenPath = (pathname: string): boolean =>
    pathname === '' ||
    pathname === '/' ||
    pathname === RouteConfig.login.path ||
    pathname.startsWith(`${RouteConfig.login.path}/`);
